/**
 * Custom react hook wrapper around 'react-responsive' that already has our media queries defined
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import { useMediaQuery as useReactResponsiveMediaQuery } from 'react-responsive'
import styles from './useMediaQuery.scss'

const useMediaQuery = () => ({
  isMobile: useReactResponsiveMediaQuery({ maxWidth: styles.mobileWidth }),
  isTablet: useReactResponsiveMediaQuery({ maxWidth: styles.tabletWidth }),
  isLaptop: useReactResponsiveMediaQuery({ maxWidth: styles.laptopWidth }),
  isDesktop: useReactResponsiveMediaQuery({ maxWidth: styles.desktopWidth }),
  isRetina: useReactResponsiveMediaQuery({ maxWidth: styles.retinaWidth }),
  isPortrait: useReactResponsiveMediaQuery({ orientation: 'portrait' }),
  isLandscape: useReactResponsiveMediaQuery({ orientation: 'landscape' }),
  isMobileHeight: useReactResponsiveMediaQuery({ maxHeight: styles.mobileHeight })
})

export default useMediaQuery
